import { Box, Button, Grid, Stack, Tooltip, Typography } from '@mui/material';
import React from 'react';
import FilterChips from './FilterChips';
import FilterPopover from './FilterPopover';
import SearchInput from './SearchInput';

export interface FilterItem {
  key: string;
  label: string;
  checked: boolean;
  onChange: () => void;
}

export interface FilterSection {
  id: string;
  header?: string;
  disableHeader?: boolean;
  type?: 'checkbox' | 'radio';
  items?: FilterItem[];
  customContent?: React.ReactNode;
  isClearDisabled?: boolean;
  onClear?: () => void;
}

export interface FilterChip {
  label: string;
  onDelete: () => void;
}

interface Props {
  filterStr?: string;
  onFilterStrChange?: (value: string) => void;
  sections: FilterSection[];
  chips: FilterChip[];
  countCaption?: string;
  actionButton?: { id: string; label: string; onClick: () => void; disabled?: boolean; tooltip?: string };
  onClearAll?: () => void;
}

const SearchAndFilters: React.FC<Props> = ({
  filterStr = '',
  onFilterStrChange,
  sections,
  chips,
  countCaption,
  actionButton,
  onClearAll
}) => {
  return (
    <Stack spacing={2}>
      <Grid
        container
        direction={{ xs: 'column-reverse', sm: 'row' }}
        spacing={2}
        justifyContent="space-between"
        wrap="nowrap"
      >
        <Grid container width="100%" direction="row" spacing={1} wrap="nowrap">
          {onFilterStrChange && <SearchInput filterStr={filterStr} onFilterStrChange={onFilterStrChange} />}
          {sections.length > 0 && <FilterPopover sections={sections} hasActiveChips={chips.length > 0} />}
          {countCaption && (
            <Typography
              color="textSecondary"
              variant="caption"
              sx={{ alignSelf: 'center', display: { xs: 'none', md: 'block' } }}
            >
              {countCaption}
            </Typography>
          )}
        </Grid>
        {actionButton && (
          <Tooltip title={actionButton.tooltip ?? ''} disableHoverListener={!actionButton.tooltip}>
            <Box component="span" sx={{ display: 'inline-flex', width: { xs: '100%', sm: 'auto' } }}>
              <Button
                id={actionButton.id}
                size="medium"
                variant="contained"
                color="primary"
                sx={{ width: '100%', padding: { md: '0 22px' }, whiteSpace: 'nowrap' }}
                onClick={actionButton.onClick}
                disabled={actionButton.disabled}
              >
                {actionButton.label}
              </Button>
            </Box>
          </Tooltip>
        )}
      </Grid>
      {chips.length > 0 && <FilterChips chips={chips} onClearAll={onClearAll} />}
    </Stack>
  );
};

export default SearchAndFilters;
